module.exports = __webpack_public_path__ + "img/as.cb630927.svg";